import React from 'react';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
export function ComparisonTable() {
  const rows = [{
    feature: 'Mess Control',
    snugges: true,
    regular: false,
    mats: false,
    snuggesText: 'No-spill floating disc',
    regularText: 'Splashes everywhere',
    matsText: 'Liquid runs off edges'
  }, {
    feature: 'Duration',
    snugges: true,
    regular: false,
    mats: 'partial',
    snuggesText: '10-20 minutes',
    regularText: '30 seconds',
    matsText: '2-5 mins (if frozen)'
  }, {
    feature: 'Calming Effect',
    snugges: true,
    regular: false,
    mats: 'partial',
    snuggesText: 'Slow, soothing licking',
    regularText: 'Frantic gulping',
    matsText: 'Moderate'
  }, {
    feature: 'Cleanup',
    snugges: true,
    regular: 'partial',
    mats: false,
    snuggesText: 'Dishwasher safe, 1-piece',
    regularText: 'Sticky bowls',
    matsText: 'Crevices trap gunk'
  }, {
    feature: 'Price',
    snugges: true,
    regular: true,
    mats: true,
    snuggesText: '$34.90',
    regularText: '$8-15',
    matsText: '$10-20'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="my-12 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-xl" data-id="element-14">
      <div className="bg-gray-50 p-6 text-center border-b border-gray-200" data-id="element-15">
        <h3 className="text-2xl font-bold text-gray-900" data-id="element-16">
          Comparison at a Glance
        </h3>
      </div>

      <div className="overflow-x-auto" data-id="element-17">
        <table className="w-full min-w-[600px] text-left border-collapse" data-id="element-18">
          <thead data-id="element-19">
            <tr className="bg-gray-50/50" data-id="element-20">
              <th className="p-4 text-sm font-semibold text-gray-500 uppercase tracking-wider w-1/4" data-id="element-21">
                Feature
              </th>
              <th className="p-4 text-center bg-[#9AC1F0]/10 border-t-4 border-[#9AC1F0] w-1/4" data-id="element-22">
                <div className="font-bold text-[#9AC1F0] text-lg" data-id="element-23">
                  🐾 Snugges
                </div>
                <div className="text-xs text-[#9AC1F0] font-medium" data-id="element-24">
                  Lick Bowl
                </div>
              </th>
              <th className="p-4 text-center text-gray-600 font-semibold w-1/4" data-id="element-25">
                🥣 Regular Bowls
              </th>
              <th className="p-4 text-center text-gray-600 font-semibold w-1/4" data-id="element-26">
                🧩 Lick Mats
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100" data-id="element-27">
            {rows.map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/30'} data-id="element-28">
                <td className="p-4 font-medium text-gray-900" data-id="element-29">{row.feature}</td>

                {/* Snugges Column */}
                <td className="p-4 bg-[#9AC1F0]/5 text-center" data-id="element-30">
                  <div className="flex flex-col items-center gap-1" data-id="element-31">
                    <div className="rounded-full bg-green-100 p-1" data-id="element-32">
                      <Check className="h-5 w-5 text-green-600" data-id="element-33" />
                    </div>
                    <span className="text-sm font-medium text-gray-900" data-id="element-34">
                      {row.snuggesText}
                    </span>
                  </div>
                </td>

                {/* Regular Column */}
                <td className="p-4 text-center" data-id="element-35">
                  <div className="flex flex-col items-center gap-1" data-id="element-36">
                    {row.regular === true ? <span className="text-sm text-gray-600" data-id="element-37">
                        {row.regularText}
                      </span> : row.regular === 'partial' ? <>
                        <div className="rounded-full bg-yellow-100 p-1" data-id="element-38">
                          <span className="block h-5 w-5 text-center font-bold text-yellow-600 leading-5" data-id="element-39">
                            !
                          </span>
                        </div>
                        <span className="text-sm text-gray-600" data-id="element-40">
                          {row.regularText}
                        </span>
                      </> : <>
                        <div className="rounded-full bg-red-100 p-1" data-id="element-41">
                          <X className="h-5 w-5 text-red-600" data-id="element-42" />
                        </div>
                        <span className="text-sm text-gray-600" data-id="element-43">
                          {row.regularText}
                        </span>
                      </>}
                  </div>
                </td>

                {/* Mats Column */}
                <td className="p-4 text-center" data-id="element-44">
                  <div className="flex flex-col items-center gap-1" data-id="element-45">
                    {row.mats === true ? <span className="text-sm text-gray-600" data-id="element-46">
                        {row.matsText}
                      </span> : row.mats === 'partial' ? <>
                        <div className="rounded-full bg-yellow-100 p-1" data-id="element-47">
                          <span className="block h-5 w-5 text-center font-bold text-yellow-600 leading-5" data-id="element-48">
                            ⚠️
                          </span>
                        </div>
                        <span className="text-sm text-gray-600" data-id="element-49">
                          {row.matsText}
                        </span>
                      </> : <>
                        <div className="rounded-full bg-red-100 p-1" data-id="element-50">
                          <X className="h-5 w-5 text-red-600" data-id="element-51" />
                        </div>
                        <span className="text-sm text-gray-600" data-id="element-52">
                          {row.matsText}
                        </span>
                      </>}
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="p-3 text-xs text-gray-400 text-center bg-gray-50" data-id="element-53">
        *Regular bowls based on standard dog water/food bowls; Lick mats based
        on flat silicone enrichment mats
      </div>
    </motion.div>;
}